import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';

import { CF_NEU_BLD } from '../../constants';
import { useInvertedLocalize } from '../../hooks/use-invertedlocalize';

interface AccountChipProps {
  visibleAccountName: string;
  accountCount: number;
  isPrefixInterpoint?: boolean;
}

/**
 * Account chip component for displaying account information
 */
function SodAccountChip({
  visibleAccountName,
  accountCount,
  isPrefixInterpoint,
}: AccountChipProps) {
  const l = useInvertedLocalize();
  const accountLabelText = `${l('Account')}: `;
  const countText = ` +${accountCount - 1}`;

  return (
    <Box className='Sod-ViolationsTabList-listRowAccountStat'>
      <Typography kind='body2' className={CF_NEU_BLD} lineLimit={1}>
        <span className='Sod-ViolationsTabList-listRowAccountStat--isLabel'>
          {accountLabelText}
        </span>
        {visibleAccountName}
        {accountCount > 1 && (
          <span className='Sod-ViolationsTabList-listRowAccountStat--isCount'>
            {countText}
          </span>
        )}
      </Typography>
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </Box>
  );
}

SodAccountChip.defaultProps = {
  isPrefixInterpoint: false,
};

export default SodAccountChip;
